import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M20 19.1111C20 19.602 19.602 20 19.1111 20H4.88889C4.39797 20 4 19.602 4 19.1111C4 18.6202 4.39797 18.2222 4.88889 18.2222H19.1111C19.602 18.2222 20 18.6202 20 19.1111ZM8.44444 11.2222C8.44444 10.6699 7.99673 10.2222 7.44444 10.2222H5.88889C5.3366 10.2222 4.88889 10.6699 4.88889 11.2222V15.4444C4.88889 15.9967 5.3366 16.4444 5.88889 16.4444H7.44444C7.99673 16.4444 8.44444 15.9967 8.44444 15.4444V11.2222ZM13.7778 5C13.7778 4.44771 13.3301 4 12.7778 4H11.2222C10.6699 4 10.2222 4.44772 10.2222 5V15.4444C10.2222 15.9967 10.6699 16.4444 11.2222 16.4444H12.7778C13.3301 16.4444 13.7778 15.9967 13.7778 15.4444V5ZM19.1111 7.66667C19.1111 7.11438 18.6634 6.66667 18.1111 6.66667H16.5556C16.0033 6.66667 15.5556 7.11438 15.5556 7.66667V15.4444C15.5556 15.9967 16.0033 16.4444 16.5556 16.4444H18.1111C18.6634 16.4444 19.1111 15.9967 19.1111 15.4444V7.66667Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }